// Shown on the auth pages when Supabase keys haven't been added yet, so it's
// obvious why sign-in isn't working (and how to fix it).
export default function ConfigNotice() {
  return (
    <div className="config-notice">
      <strong>⚙️ Backend not connected yet.</strong>
      <p>
        Add your Supabase <code>URL</code> and <code>anon key</code> to <code>.env.local</code>, run the
        SQL in <code>supabase/schema.sql</code>, then restart the dev server. See{' '}
        <code>README.md</code> → “Backend setup”.
      </p>
    </div>
  )
}
